/* HCORZ
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 14/07/2025 | Lic. José Luis Aragón Cervantes  | Creación
* ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isErrorForm, isNullOrEmpty, tiempoCierreSession } from '../../utils/Utils'
import { useLayout } from "../../context/System/LayoutContext";
import { useSesion } from "../../context/System/SesionContext";
import axios from "axios"
import getParamsEnv from '../../utils/getParamsEnv'

export const CalibracionContext = createContext();

export const CalibracionProvider = (props) => {
    const [listaCompanias, setListaCompanias] = useState([]);
    const [listaPlantas, setListaPlantas] = useState([]);
    const [listaMesasCarga, setListaMesasCarga] = useState([]);
    const [listaBrazos, setListaBrazos] = useState([]);
    const [listaProductos, setListaProductos] = useState([]);
    const [listaTiposFlujo, setListaTiposFlujo] = useState([]);
    const [datosGraficas, setDatosGraficas] = useState({});
    const [filtros, setFiltros] = useState({
        compania: "",
        planta: "",
        mesacarga: "",
        brazo: "",
        producto: "",
        tipoFlujo: "",
        fechaInicio: "",
        fechaFin: "",
    });

    const { handleOpenAlert } = useLayout();
    const { API_URL_BASE } = getParamsEnv();

    const handleObtenerListaConpanias = async () => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return;
            }
            const companiasResult = await axios.get(`${API_URL_BASE}calibracion/companiaslist`, {
                headers: { Authorization: `Bearer ${tokenSeguridad}` },
            });
            if (companiasResult.status !== 200) {
                handleOpenAlert("Error al obtener lista de compañías", "error");
                return;
            }
            setListaCompanias(companiasResult?.data);
        } catch (error) {
            console.error("Error:", error);
            handleOpenAlert("Ocurrió un error inesperado al cargar compañías: " + error.message, "error");
        }
    };

    const handleObtenerListaPlantas = async () => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return;
            }
            const plantasResult = await axios.get(`${API_URL_BASE}calibracion/plantaslist`, {
                headers: { Authorization: `Bearer ${tokenSeguridad}` },
            });
            if (plantasResult.status !== 200) {
                handleOpenAlert("Error al obtener lista de plantas", "error");
                return;
            }
            setListaPlantas(plantasResult?.data);
        } catch (error) {
            console.error("Error:", error);
            handleOpenAlert("Ocurrió un error inesperado al cargar plantas: " + error.message, "error");
        }
    };

    const handleObtenerListaMesasCarga = async () => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return;
            }
            const mesasCargaResult = await axios.get(`${API_URL_BASE}calibracion/mesascargalist`, {
                headers: { Authorization: `Bearer ${tokenSeguridad}` },
            });
            if (mesasCargaResult.status !== 200) {
                handleOpenAlert("Error al obtener lista de mesas de carga", "error");
                return;
            }
            setListaMesasCarga(mesasCargaResult?.data);
        } catch (error) {
            console.error("Error:", error);
            handleOpenAlert("Ocurrió un error inesperado al cargar mesas de carga: " + error.message, "error");
        }
    };

    const handleObtenerListaBrazos = async () => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return;
            }
            const brazosResult = await axios.get(`${API_URL_BASE}calibracion/brazoslist`, {
                headers: { Authorization: `Bearer ${tokenSeguridad}` },
            });
            if (brazosResult.status !== 200) {
                handleOpenAlert("Error al obtener lista de brazos", "error");
                return;
            }
            setListaBrazos(brazosResult?.data);
        } catch (error) {
            console.error("Error:", error);
            handleOpenAlert("Ocurrió un error inesperado al cargar brazos: " + error.message, "error");
        }
    };

    const handleObtenerMesaListaBrazos = async (mesa) => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return;
            }
            const brazosResult = await axios.get(`${API_URL_BASE}calibracion/brazosmesalist`, {
                headers: { Authorization: `Bearer ${tokenSeguridad}` },
                params: { mesa }
            });
            if (brazosResult.status !== 200) {
                handleOpenAlert("Error al obtener lista de brazos", "error");
                return;
            }
            setListaBrazos(brazosResult?.data);
        } catch (error) {
            console.error("Error:", error);
            handleOpenAlert("Ocurrió un error inesperado al cargar brazos: " + error.message, "error");
        }
    };

    const handleObtenerListaProductos = async () => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return;
            }
            const productosResult = await axios.get(`${API_URL_BASE}calibracion/productoslist`, {
                headers: { Authorization: `Bearer ${tokenSeguridad}` },
            });
            if (productosResult.status !== 200) {
                handleOpenAlert("Error al obtener lista de productos", "error");
                return;
            }
            setListaProductos(productosResult?.data);
        } catch (error) {
            console.error("Error:", error);
            handleOpenAlert("Ocurrió un error inesperado al cargar productos: " + error.message, "error");
        }
    };

    const handleObtenerListaTiposFlujo = async () => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return;
            }
            const tiposflujoResult = await axios.get(`${API_URL_BASE}calibracion/tiposflujolist`, {
                headers: { Authorization: `Bearer ${tokenSeguridad}` },
            });
            if (tiposflujoResult.status !== 200) {
                handleOpenAlert("Error al obtener lista de tipos de flujo", "error");
                return;
            }
            setListaTiposFlujo(tiposflujoResult?.data);
        } catch (error) {
            console.error("Error:", error);
            handleOpenAlert("Ocurrió un error inesperado al cargar tipos de flujo: " + error.message, "error");
        }
    };

    const handleFiltroChange = (e) => {
        setFiltros({ ...filtros, [e.target.name]: e.target.value });
    };

    const handleobtenerDatosGraficas = async (filtrosParam = null) => {
        const filtrosFinales = filtrosParam || filtros;
        try {
            if (!filtrosFinales.fechaInicio || !filtrosFinales.fechaFin) {
                return;
            }
            const anioInicio = new Date(filtrosFinales.fechaInicio).getFullYear();
            const anioFin = new Date(filtrosFinales.fechaFin).getFullYear();
            if (anioInicio < 1000 || anioFin < 1000) {
                return;
            }
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) return;

            const graficasResult = await axios.post(
                `${API_URL_BASE}calibracion/datagraficas`,
                filtrosFinales,
                {
                    headers: {
                        Authorization: `Bearer ${tokenSeguridad}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (graficasResult.status === 200) {
                setDatosGraficas(graficasResult?.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const saveCalibracionDocument = async (head, details) => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            if (!tokenSeguridad) {
                handleOpenAlert("Token de seguridad no encontrado", "error");
                return false;
            }

            const response = await axios.post(
                `${API_URL_BASE}calibracion/documento`,
                { head, details },
                {
                    headers: {
                        Authorization: `Bearer ${tokenSeguridad}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                handleOpenAlert("Documento guardado exitosamente.", "success");
                return true;
            }
            return false;

        } catch (error) {
            console.error("Error saving document:", error);
            const msg = error.response?.data?.message || error.message;
            handleOpenAlert("Error al guardar documento: " + msg, "error");
            return false;
        }
    };

    const checkFileExists = async (filename) => {
        try {
            const tokenSeguridad = localStorage.getItem("token");
            const response = await axios.get(
                `${API_URL_BASE}calibracion/documento/exists`,
                {
                    headers: { Authorization: `Bearer ${tokenSeguridad}` },
                    params: { filename }
                }
            );
            return response.data.exists;
        } catch (error) {
            return false;
        }
    };

    return (
        <CalibracionContext.Provider
            value={{
                filtros, setFiltros,
                handleFiltroChange,
                listaCompanias,
                handleObtenerListaConpanias,
                listaPlantas,
                handleObtenerListaPlantas,
                listaMesasCarga,
                handleObtenerListaMesasCarga,
                listaBrazos,
                handleObtenerListaBrazos,
                handleObtenerMesaListaBrazos,
                listaProductos,
                handleObtenerListaProductos,
                listaTiposFlujo,
                handleObtenerListaTiposFlujo,
                handleobtenerDatosGraficas,
                datosGraficas,
                saveCalibracionDocument,
                checkFileExists
            }}>
            {props.children}
        </CalibracionContext.Provider>
    );
};

export const useCalibracion = () => useContext(CalibracionContext);